import React, { useEffect, useState } from 'react'
// import React from 'react'
import Container from '../container/Container'
import Stake from './stake/Stake'
import Operations from './operations/Operations'
import Set from './set/Set'
import Back from './back/Back'
import { SetStakeProps } from './interfaces'
import { Main } from './SetStakeStyled'
import useStakeOperations from 'functions/stakeOperations/useStakeOperations'
import {
  checkOnlyDot,
  checkForEmpty,
  checkStartWithZeros,
  checkMaxMin,
} from '../../components/input/helpers/checkerFunctions'
import SFXS from '../../assets/audios/audios'

export default function SetStake({
  gameInfo,
  stake,
  handleStake,
  handleAbove,
  colors,
  handleNotification,
  audio,
  isZero,
  size,
}: SetStakeProps) {
  const { minBet, maxBet, precision, currency } = gameInfo

  const [number, setnumber] = useState(stake)
  const [
    finalStake,
    makeMathOperation,
    ,
    inputStake,
    setinputStake,
  ] = useStakeOperations(
    number,
    minBet,
    maxBet,
    precision,
    audio,
    handleNotification,
    currency,
    isZero,
  )

  useEffect(() => {
    setnumber(finalStake)
  }, [finalStake])

  const handleSetStake = (b: boolean) => {
    // console.log('handleSetStake', inputStake)
    if (b) {
      // const emp = checkForEmpty(inputStake)
      if (checkForEmpty(inputStake)) {
        return handleStake(minBet)
      }
      if (checkOnlyDot(inputStake)) {
        return handleStake(minBet)
      }

      const z: string = checkStartWithZeros(inputStake)
      const m = currency
        ? checkMaxMin(
            z,
            maxBet,
            minBet,
            handleNotification,
            currency,
            precision,
            isZero,
          )
        : checkMaxMin(
            z,
            maxBet,
            minBet,
            handleNotification,
            currency,
            precision,
            isZero,
          )
      const f = (+m).toFixed(precision)
      handleStake(f)
      setTimeout(() => {
        handleAbove(false)
      }, 320)
    }
  }

  return (
    <Container unBlur={false}>
      <Main data-testid='setStake'>
        <Stake
          currency={currency}
          stake={inputStake}
          min={minBet}
          max={maxBet}
          setnumber={setnumber}
          setinputStake={setinputStake}
          handleNotification={handleNotification}
          isZero={isZero}
          colors={colors}
          toFix={precision}
          size={size}
        />
        <Operations makeMathOperation={makeMathOperation} colors={colors} />
        <Set setStake={handleSetStake} audio={audio} colors={colors} />
        <Back func={handleAbove} sfx={SFXS.goBackSFX} />
      </Main>
    </Container>
  )
}
